(function () {
  if (!document.body.classList.contains('template-product')) return;

  function moveOfferAfterPrice() {
    var priceWrap = document.querySelector(
      '.product-details .group-block > .group-block .text-block:has(.price), .product-details .price-block'
    );
    var price = document.querySelector('.product-details .price');
    var anchor = priceWrap || price;
    if (!anchor) return;

    var offer = document.querySelector('.product-details .viimpii-pdp-offer');
    if (!offer) {
      var tpl = document.getElementById('viimpii-pdp-offer-tpl');
      if (tpl && tpl.content.firstElementChild) {
        offer = tpl.content.firstElementChild.cloneNode(true);
      }
    }
    if (!offer) return;

    if (offer.previousElementSibling !== anchor) {
      anchor.insertAdjacentElement('afterend', offer);
    }
  }

  function addBestsellerBadge() {
    if (document.querySelector('.viimpii-pdp-bestseller')) return;

    var priceRow =
      document.querySelector('.product-details .price') ||
      document.querySelector('.product-details .price-block');
    if (!priceRow) return;

    var badge = document.createElement('span');
    badge.className = 'viimpii-pdp-bestseller';
    badge.textContent = 'BESTSELLER';

    var row = document.createElement('div');
    row.className = 'viimpii-pdp-price-row';

    var parent = priceRow.parentElement;
    if (!parent) return;

    parent.insertBefore(row, priceRow);
    row.appendChild(priceRow);
    row.appendChild(badge);
  }

  function moveAvailableShades() {
    // Server-rendered above quantity in buy-buttons.liquid
    var mounted = document.querySelector('[data-viimpii-shades-mount] .viimpii-pdp-available-shades');
    if (mounted) {
      document.querySelectorAll('.product-details .viimpii-pdp-available-shades').forEach(function (el) {
        if (el !== mounted && !mounted.contains(el)) el.remove();
      });
      document.dispatchEvent(new CustomEvent('viimpii:shades-ready'));
      return;
    }

    var tpl = document.getElementById('viimpii-pdp-shades-tpl');
    var existing = document.querySelector('.product-details .viimpii-pdp-available-shades');
    var shades =
      existing ||
      (tpl && (tpl.content.querySelector('.viimpii-pdp-available-shades') || tpl.content.firstElementChild));

    if (!shades || !shades.classList || !shades.classList.contains('viimpii-pdp-available-shades')) {
      return;
    }

    var node = existing || shades.cloneNode(true);
    var buyButtons = document.querySelector('.product-details .buy-buttons-block');
    var quantityWrapper = document.querySelector('.product-details .quantity-selector-wrapper');

    if (buyButtons && buyButtons.parentNode) {
      buyButtons.parentNode.insertBefore(node, buyButtons);
    } else if (quantityWrapper && quantityWrapper.parentNode) {
      quantityWrapper.parentNode.insertBefore(node, quantityWrapper);
    }

    document.dispatchEvent(new CustomEvent('viimpii:shades-ready'));
  }

  function addSaleBadge() {
    var saleRow = document.querySelector('.product-details .price__sale:not(.price__hidden)');
    if (!saleRow || saleRow.querySelector('.viimpii-pdp-sale-badge')) return;

    var compareEl = saleRow.querySelector('.compare-at-price');
    var saleEl = saleRow.querySelector('.price-item--sale');
    if (!compareEl || !saleEl) return;

    var compareText = compareEl.textContent.replace(/[^\d.]/g, '');
    var saleText = saleEl.textContent.replace(/[^\d.]/g, '');
    var compareVal = parseFloat(compareText);
    var saleVal = parseFloat(saleText);
    if (!compareVal || !saleVal || compareVal <= saleVal) return;

    var pct = Math.round(((compareVal - saleVal) / compareVal) * 100);
    var badge = document.createElement('span');
    badge.className = 'viimpii-pdp-sale-badge';
    badge.textContent = pct + '% OFF';
    saleRow.appendChild(badge);
  }

  function enhanceDescription() {
    var buyButtons = document.querySelector('.product-details .buy-buttons-block');
    if (!buyButtons) return;

    var node = buyButtons.nextElementSibling;
    while (node && !node.classList.contains('viimpii-pdp-description')) {
      if (node.classList.contains('text-block') || node.querySelector('.rte')) break;
      node = node.nextElementSibling;
    }

    if (!node || node.classList.contains('viimpii-pdp-description')) return;
    if (!node.classList.contains('text-block') && !node.querySelector('.rte')) return;

    var wrap = document.createElement('div');
    wrap.className = 'viimpii-pdp-description viimpii-pdp-description--synopsis';

    var body = document.createElement('div');
    body.className = 'viimpii-pdp-description__body';
    body.innerHTML = node.innerHTML;

    var firstHeading = body.querySelector('h1, h2, h3, strong');
    if (firstHeading && /about this product/i.test(firstHeading.textContent.trim())) {
      firstHeading.remove();
    }

    // Remove "Shade: …" lines from product description (shown under bullets)
    body.querySelectorAll('p, li').forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^shade\s*:/i.test(text)) el.remove();
    });
    body.innerHTML = body.innerHTML.replace(/<p[^>]*>\s*Shade\s*:[\s\S]*?<\/p>/gi, '');

    wrap.appendChild(body);
    node.replaceWith(wrap);
  }

  function stripShadeLabels() {
    document.querySelectorAll('.product-details .rte p, .product-details .text-block p, .product-details .viimpii-pdp-description__body p').forEach(function (el) {
      if (el.classList.contains('viimpii-pdp-meta') || el.closest('.viimpii-pdp-meta')) return;
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^shade\s*:/i.test(text)) el.remove();
    });
  }

  function moveFeatures() {
    var tpl = document.getElementById('viimpii-pdp-features-tpl');
    if (!tpl || document.querySelector('.viimpii-pdp-features')) return;

    var features = tpl.content.firstElementChild;
    if (!features) return;

    var desc = document.querySelector('.product-details .viimpii-pdp-description');
    var buyButtons = document.querySelector('.product-details .buy-buttons-block');
    var wishlist = document.querySelector('.product-details .viimpii-pdp-wishlist');

    if (desc) {
      desc.insertAdjacentElement('afterend', features.cloneNode(true));
      return;
    }
    if (wishlist) {
      wishlist.insertAdjacentElement('afterend', features.cloneNode(true));
      return;
    }
    if (buyButtons) {
      buyButtons.insertAdjacentElement('afterend', features.cloneNode(true));
    }
  }

  function showWishlistToast(message) {
    var existing = document.querySelector('.viimpii-pdp-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'viimpii-pdp-toast';
    toast.setAttribute('role', 'status');
    toast.textContent = message;
    document.body.appendChild(toast);

    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () {
        toast.remove();
      }, 280);
    }, 2200);
  }

  function addWishlistButton() {
    var buyButtons = document.querySelector('.product-details .buy-buttons-block');
    if (!buyButtons || document.querySelector('.viimpii-pdp-wishlist')) return;

    var productId = null;
    var productHandle = '';
    var idEl = document.querySelector('product-form [name="product-id"], [data-product-id], form[action*="/cart/add"] [name="id"]');
    var form = document.querySelector('.product-details form[action*="/cart/add"], product-form-component form');
    if (form) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput) productId = idInput.value;
    }
    try {
      productHandle = window.location.pathname.split('/products/')[1] || '';
      productHandle = productHandle.split('?')[0].split('#')[0];
    } catch (e) {}

    var key = 'viimpii_wishlist';
    function readList() {
      try {
        return JSON.parse(localStorage.getItem(key) || '[]');
      } catch (e) {
        return [];
      }
    }
    function writeList(list) {
      try {
        localStorage.setItem(key, JSON.stringify(list));
      } catch (e) {}
    }
    function isSaved() {
      var list = readList();
      return list.some(function (item) {
        return (productHandle && item.handle === productHandle) || (productId && String(item.variantId) === String(productId));
      });
    }
    function syncLabel() {
      var saved = isSaved();
      btn.textContent = saved ? 'WISHLISTED' : 'WISHLIST';
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'viimpii-pdp-wishlist';
    btn.addEventListener('click', function () {
      var list = readList();
      if (isSaved()) {
        list = list.filter(function (item) {
          return !((productHandle && item.handle === productHandle) || (productId && String(item.variantId) === String(productId)));
        });
        writeList(list);
        syncLabel();
        showWishlistToast('Removed from wishlist');
        return;
      }
      list.push({
        handle: productHandle,
        variantId: productId,
        title: document.title.replace(/\s*[–-|].*$/, '').trim(),
        url: window.location.pathname,
        savedAt: Date.now(),
      });
      writeList(list);
      syncLabel();
      showWishlistToast('Saved to wishlist');
    });

    buyButtons.insertAdjacentElement('afterend', btn);
    syncLabel();
  }

  function initPdpTabs() {
    document.querySelectorAll('[data-viimpii-pdp-tabs]').forEach(function (root) {
      if (root.dataset.tabsReady === '1') return;
      root.dataset.tabsReady = '1';

      var tabs = root.querySelectorAll('.viimpii-pdp-tabs__tab');
      var panels = root.querySelectorAll('.viimpii-pdp-tabs__panel');
      if (!tabs.length) return;

      function activate(id) {
        tabs.forEach(function (t) {
          var active = t.getAttribute('data-tab') === id;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var match = panel.getAttribute('data-panel') === id;
          panel.classList.toggle('is-active', match);
          if (match) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
      }

      root.addEventListener('click', function (e) {
        var tab = e.target.closest('.viimpii-pdp-tabs__tab');
        if (!tab || !root.contains(tab)) return;
        e.preventDefault();
        activate(tab.getAttribute('data-tab'));
      });
    });
  }

  function enhanceZoomDialog() {
    document.querySelectorAll('zoom-dialog').forEach(function (zoomDialog) {
      var dialogEl = zoomDialog.querySelector('dialog');
      if (!dialogEl) return;

      function upgradeZoomImages() {
        zoomDialog.querySelectorAll('.dialog-zoomed-gallery img.product-media__image').forEach(function (img) {
          var hiRes = img.getAttribute('data_max_resolution');
          if (!hiRes) return;

          if (img.src !== hiRes) {
            img.src = hiRes;
          }

          img.removeAttribute('srcset');
          img.sizes = '100vw';
        });

        zoomDialog.querySelectorAll('.product-media__drag-zoom-wrapper').forEach(function (wrapper) {
          wrapper.style.setProperty('--drag-zoom-scale', '1');
          wrapper.style.setProperty('--drag-zoom-translate-x', '0px');
          wrapper.style.setProperty('--drag-zoom-translate-y', '0px');
        });
      }

      function onDialogOpen() {
        if (!dialogEl.open) return;
        upgradeZoomImages();

        if (typeof zoomDialog.loadHighResolutionImage === 'function' && zoomDialog.refs && zoomDialog.refs.media) {
          zoomDialog.refs.media.forEach(function (container) {
            zoomDialog.loadHighResolutionImage(container);
          });
        }
      }

      var observer = new MutationObserver(onDialogOpen);
      observer.observe(dialogEl, { attributes: true, attributeFilter: ['open'] });

      dialogEl.addEventListener('close', function () {
        zoomDialog.querySelectorAll('.product-media__drag-zoom-wrapper').forEach(function (wrapper) {
          wrapper.style.setProperty('--drag-zoom-scale', '1');
          wrapper.style.setProperty('--drag-zoom-translate-x', '0px');
          wrapper.style.setProperty('--drag-zoom-translate-y', '0px');
        });
      });
    });
  }

  function initProductPage() {
    // Tabs first so clicks work even if later enhancers throw
    try { initPdpTabs(); } catch (e) {}

    try { addBestsellerBadge(); } catch (e) {}
    try { moveOfferAfterPrice(); } catch (e) {}
    try { moveAvailableShades(); } catch (e) {}
    try { addSaleBadge(); } catch (e) {}
    try { enhanceDescription(); } catch (e) {}
    try { stripShadeLabels(); } catch (e) {}
    try { addWishlistButton(); } catch (e) {}

    // Keep wishlist between ATC and short description when synopsis exists
    try {
      var wishlistBtn = document.querySelector('.product-details .viimpii-pdp-wishlist');
      var synopsis = document.querySelector('.product-details .viimpii-pdp-description--synopsis');
      if (wishlistBtn && synopsis && synopsis.previousElementSibling !== wishlistBtn) {
        synopsis.insertAdjacentElement('beforebegin', wishlistBtn);
      }
    } catch (e) {}

    try { moveFeatures(); } catch (e) {}
    try { enhanceZoomDialog(); } catch (e) {}

    document.querySelectorAll('.viimpii-pdp-breadcrumbs a').forEach(function (link) {
      if (link.getAttribute('href') === window.location.pathname) {
        link.setAttribute('aria-current', 'page');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductPage);
  } else {
    initProductPage();
  }
})();
